
import React from 'react';
import { Text } from '../../../../../ui-kit';
import '../styles/_badge-status.scss';






const BadgeStatus = ({ type, labelText }) => {
  const getClassName = () => {
    switch (type) {
      case 'PRIMARY':
        return 'badge-status--primary';
      case 'SECONDARY':
        return 'badge-status--secondary';
      case 'WARNING':
        return 'badge-status--warning';
      default:
        return '';
    }
  };

  return (
    <Text className={`badge-status ${getClassName()}`}>
      {labelText}
    </Text>);

};

export default BadgeStatus;